import { useObrasCards } from "./use-obras-cards";
import { ObrasCardsView } from "./view-obras-cards";
import type { ObrasCardsProps } from "./types-obras-cards";

export function ObrasCards(props: ObrasCardsProps) {
  const vm = useObrasCards(props);

  return <ObrasCardsView {...vm} />;
}

export type * from "./types-obras-cards";
